import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextField from 'shared/components/text-field/TextField';
import Button from 'shared/components/button/Button';
import PasswordField from 'shared/components/password-field/PasswordField';
import SelectDropdown from 'shared/components/select-dropdown/SelectDropdown';
import { registerSchema } from 'utils/validators/register';
import { AuthContext } from 'features/auth/context/Auth';
import sideBg from 'assets/img/content/register.png';
import './Register.scss';
import {
  signup,
  resendVerificationEmail,
  getGyms
} from '../../ducks/authActions';
import VerificationEmailIsSent from './VerificationEmailIsSent';

const Register = props => {
  let { authMsg, loginUser, loading, getGyms, gyms } = props;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [readonly, setReadonly] = useState(true);
  const [gymsOptions, setGyms] = useState([]);

  const { currentUser } = useContext(AuthContext) || {};

  const resendVerification = () => {
    props.resendVerificationEmail(email, password);
  };

  useEffect(() => {
    getGyms();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    gyms && setGyms(gyms.map(gym => ({ value: gym.id, option: gym.name })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, gyms);

  if (loginUser) {
    return (
      <VerificationEmailIsSent
        resendVerification={resendVerification}
        loading={loading}
      />
    );
  }

  if (!loading && currentUser && currentUser.emailVerified) {
    const { from } = props.location.state || { from: { pathname: '/' } };
    return <Redirect to={from} />;
  }

  return (
    <Formik
      initialValues={{
        first_name: '',
        last_name: '',
        email: '',
        password: ''
      }}
      onSubmit={values => {
        setEmail(values.email);
        setPassword(values.password);
        return props.signup(
          values.first_name,
          values.last_name,
          values.email,
          values.password,
          values.gym_id
        );
      }}
      validationSchema={registerSchema}
      initialErrors={'email'}
      validate={() => {
        let errors = {};
        if (authMsg) errors.email = authMsg.message;
        authMsg = false;
        return errors;
      }}
    >
      {props => {
        const { isSubmitting, errors, values } = props;
        return (
          <div className="onboarding onboarding-register">
            <div className="register">
              <div className="img-side">
                <img src={sideBg} alt="sideimage" />
              </div>
              <div className="form-side">
                <div className="shape shape-left"></div>
                <div className="shape shape-right"></div>
                <div className="form-content">
                  <h3>Welcome to Hybrid Training.</h3>
                  <p className="form-hint">
                    Enter your name and email and create a password to connect
                    with your clients
                  </p>
                  <Form>
                    <div className="form-row">
                      <div className="col">
                        <TextField
                          type="text"
                          name="first_name"
                          label="First Name"
                          placeholder="First"
                        />
                      </div>
                      <div className="col">
                        <TextField
                          type="text"
                          name="last_name"
                          label="Last Name"
                          placeholder="Last"
                        />
                      </div>
                    </div>
                    <TextField
                      readOnly={readonly}
                      onFocus={e => setReadonly(false)}
                      onBlur={e => setReadonly(true)}
                      autoComplete="off"
                      type="text"
                      name="email"
                      label="Email"
                      placeholder="trainer@hybridmmafit.com"
                      error={
                        !isSubmitting && authMsg && authMsg.code
                          ? authMsg.message
                          : false
                      }
                    />
                    <SelectDropdown
                      name="gym_id"
                      options={gymsOptions}
                      label="Gym"
                    />
                    <PasswordField />
                    <div className="form-check">
                      <label
                        className={`form-check-label ${
                          values['password'].length === 0 || errors['password']
                            ? ''
                            : 'active'
                        }`}
                      >
                        <i className="fas fa-check-square"></i>
                        <span>At least 6 characters long</span>
                      </label>
                    </div>
                    <div className="form-action">
                      <Button
                        id="submit-btn"
                        type="submit"
                        btnBlock="block"
                        color="primary"
                        label="Get Started"
                        disabled={isSubmitting}
                      />
                    </div>
                  </Form>
                  <div className="form-text">
                    <p>
                      Already have an account? <Link to="login">Activate</Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

Register.propTypes = {
  fields: PropTypes.shape({
    first_name: PropTypes.shape.isRequired,
    last_name: PropTypes.isRequired,
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    gym_id: PropTypes.string.isRequired
  })
};

function mapStateToProps(state) {
  return {
    authMsg: state.authReducer.authMsg,
    loginUser: state.authReducer.loginUser,
    loading: state.authReducer.loading,
    gyms: state.authReducer.gyms
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signup: (email, password, firstName, lastName, gym_id, callback) =>
      dispatch(signup(email, password, firstName, lastName, gym_id, callback)),
    resendVerificationEmail: (email, password) =>
      dispatch(resendVerificationEmail(email, password)),
    getGyms: () => dispatch(getGyms())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);
